// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"premium_wrapper_3wnZB","background":"premium_background_G-tm8","main":"premium_main_1D8w1","childView":"premium_childView_C-Ork"};